<template>
  <div class="flex add-to-cart">
      <div class="quantity">
        <number-input
            :value="payload.quantity"
            @input="changeVal"
            />
      </div>
    <button @click="addToCart()" :disabled="disableButton" class="button">
        ADD TO CART
    </button>

  </div>
</template>

<script>
  export default {
    props: {
      id: Number
    },
    data() {
      return {
        disableButton: false,
        quantity: 1,
        payload: {
          product_id: 0,
          quantity: 1
        }
      }
    },
    created () {
      this.payload.product_id = this.id

    },
    methods: {
      changeVal (val) {
        this.payload.quantity = val
      },

      changeQty (direction) {
        if (direction == 'minus') {

          if (this.payload.quantity === 1) return

          this.payload.quantity--

        } else {
          this.payload.quantity++
        }
      },

      addToCart () {
        let quantity = parseInt(this.payload.quantity)

        if (quantity < 1) {
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>Product quantity should not be less than 1</p>',
          })

          return
        }

        this.disableButton = true

        window.axios.post('/cart', this.payload)
          .then((response) => {
            this.disableButton = false

            this.$store.commit('setCart', response.data.data)
            this.$store.dispatch('toast', 'Product added to cart')
          })
          .catch((error) => {
            this.$store.commit('setPopup', {
              open: true,
              content: '<p>' + error.response.data.message + '</p>'
            })
            this.disableButton = false
          })
      },

      changeVal (val) {
        this.payload.quantity = val
      },
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/AddToCart.vue